// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import { Link } from "react-router-dom";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useLocation } from "react-router-dom";


// const Products = () => {
//   const [allProducts, setAllProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedBrands, setSelectedBrands] = useState([]);
//   const [selectedColors, setSelectedColors] = useState([]);
//   const [discountFilter, setDiscountFilter] = useState(null);
//   const [sortOption, setSortOption] = useState("");
//   const [priceRange, setPriceRange] = useState(100000);
//   const [hoveredItemId, setHoveredItemId] = useState(null);
//   const [selectedRatings, setSelectedRatings] = useState([]);
// const [isSearchMode, setIsSearchMode] = useState(false);
// const [categoryMap, setCategoryMap] = useState({});



//   const location = useLocation();

// const queryParams = new URLSearchParams(location.search);

// const subcategoryFromUrl = queryParams.get("subcategory"); // menu click
// const categoryFromUrl = queryParams.get("category");       // other pages

// const activeSubcategory = subcategoryFromUrl
//   ? Number(subcategoryFromUrl)
//   : null;

// const activeCategory = categoryFromUrl
//   ? Number(categoryFromUrl)
//   : null;

// const categoryIdFromHome = location.state?.categoryId;
// console.log("Category from Home:", categoryIdFromHome);


// useEffect(() => {
//   const fetchCategories = async () => {
//     try {
//       const res = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
//       );
//       const data = await res.json();

//       if (data.success === "1" && Array.isArray(data.row)) {
//         const map = {};
//         data.row.forEach((cat) => {
//           map[Number(cat.category_id)] = cat.category_name;
//         });
//         setCategoryMap(map);
//       }
//     } catch (err) {
//       console.error("Category fetch failed", err);
//     }
//   };

//   fetchCategories();
// }, []);


// useEffect(() => {
//   console.log("🔍 DEBUG START");

//   console.log(
//     "Category from Home:",
//     categoryIdFromHome,
//     "TYPE:",
//     typeof categoryIdFromHome
//   );

//   console.log(
//     "Selected Categories:",
//     selectedCategories,
//     "TYPE:",
//     selectedCategories.map((c) => typeof c)
//   );

//   console.log(
//     "Product category_id list:",
//     allProducts.map((p) => p.category_id),
//     "TYPE:",
//     allProducts.map((p) => typeof p.category_id)
//   );

//   console.log("🔍 DEBUG END");
// }, [categoryIdFromHome, selectedCategories, allProducts]);

//   // Fetch products from API
// // ========================================
// // MINIMAL FIX FOR Products.jsx
// // Only change the useEffect that handles location.state
// // ========================================

// // Replace your existing useEffect for fetching products with this:

// useEffect(() => {
//   // ✅ CASE 1: If coming from search
//   if (location.state?.results) {
//     console.log("📦 Received search results:", location.state.results);
//     console.log("📦 Number of results:", location.state.results.length);
//     console.log("📦 Sample result structure:", location.state.results[0]);
    
//     // 🔥 DON'T FILTER BY admin_approval in search results
//     // The search already returns real products, just use them directly
//     setAllProducts(location.state.results);
//     setIsSearchMode(true);

//     if (location.state.results.length > 0) {
//       const maxPrice = Math.max(
//         ...location.state.results.map((p) => p.price)
//       );
//       setPriceRange(maxPrice);
//     }

//     setLoading(false);
//     return; // Stop here, don't fetch from API
//   }

//   // ✅ CASE 2: Normal product listing (UNCHANGED - KEEP YOUR EXISTING CODE)
//   const fetchProducts = async () => {
//     try {
//       setLoading(true);

//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
//       );

//       const data = await response.json();

//       if (data.status && Array.isArray(data.data)) {

//         // ✅ FILTER ONLY ADMIN APPROVED PRODUCTS (YOUR EXISTING CODE)
//         const approvedProducts = data.data.filter(
//           (item) => item.admin_approval === "approval"
//         );

//         console.log(
//           "✅ ADMIN APPROVED PRODUCTS:",
//           approvedProducts.map((p) => ({
//             product_id: p.product_id,
//             admin_approval: p.admin_approval,
//             category_id: p.category_id,
//             subcategory_id: p.subcategory_id,
//           }))
//         );

//         // ✅ TRANSFORM DATA (YOUR EXISTING CODE)
//         const transformedProducts = approvedProducts.map((product) => ({
//           id: product.product_id,
//           brand: product.company_name || product.assign_vendor,
//           name: product.product_name,
//           price: parseFloat(product.current_price),
//           oldPrice: parseFloat(product.old_price),
//           discount: Math.round(
//             ((product.old_price - product.current_price) /
//               product.old_price) *
//               100
//           ),

//           // IMPORTANT IDS
//           category_id: Number(product.category_id),
//           subcategory_id: Number(product.subcategory_id),

//           color: product.available_colors,
//           images:
//             product.multi_image?.length > 0
//               ? product.multi_image.map(
//                   (img) => `https://cyberathon.com/multivendor/${img}`
//                 )
//               : ["img/placeholder.jpg"],

//           rating: parseFloat(product.rating) || 0,
//           stock: product.status || "In Stock",
//           description: product.description,
//           productDetails: product.product_details,
//         }));

//         setAllProducts(transformedProducts);

//         // 🔥 PRIORITY HANDLING (YOUR EXISTING CODE)
//         if (activeSubcategory) {
//           setSelectedCategories([]); // ignore category when subcategory active
//         } else if (activeCategory) {
//           setSelectedCategories([activeCategory]);
//         }

//         if (categoryIdFromHome) {
//           setSelectedCategories([Number(categoryIdFromHome)]);
//         }

//         if (transformedProducts.length > 0) {
//           const maxPrice = Math.max(
//             ...transformedProducts.map((p) => p.price)
//           );
//           setPriceRange(maxPrice);
//         }
//       }

//       setLoading(false);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load products");
//       setLoading(false);
//     }
//   };

//   fetchProducts();
// }, [location.state, activeCategory, activeSubcategory, categoryIdFromHome]);


//   const settings = {
//     dots: true,
//     arrows: false,
//     infinite: true,
//     speed: 500,
//     autoplay: true,
//     autoplaySpeed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//   };

//   const handleCheckboxChange = (value, setter, stateArray) => {
//     setter(
//       stateArray.includes(value)
//         ? stateArray.filter((item) => item !== value)
//         : [...stateArray, value]
//     );
//   };

//   const handleDiscountFilter = (value) => {
//     setDiscountFilter(discountFilter === value ? null : value);
//   };

//   const handleSortChange = (e) => {
//     setSortOption(e.target.value);
//   };

//   // Get unique values for filters
// //   const uniqueCategories = [
// //   ...new Set(
// //     allProducts
// //       .map((p) => p.category_id ?? p.category)
// //       .filter(Boolean)
// //   ),
// // ];


// const uniqueCategories = [
//   ...new Set(allProducts.map((p) => Number(p.category_id)).filter(Boolean)),
// ];


//   const uniqueBrands = [...new Set(allProducts.map(p => p.brand).filter(Boolean))];
//   const uniqueColors = [...new Set(allProducts.map(p => p.color).filter(Boolean))];

//  const filteredProducts = allProducts
//   // 🔥 1️⃣ SUBCATEGORY FILTER (HIGHEST PRIORITY)
//   .filter((item) => {
//     if (activeSubcategory) {
//       return Number(item.subcategory_id) === activeSubcategory;
//     }
//     return true;
//   })

//   // 🔥 2️⃣ CATEGORY FILTER (fallback)
//   .filter((item) => {
//     if (activeSubcategory) return true; // ignore category when subcategory active
//     if (selectedCategories.length === 0) return true;
//     return selectedCategories.includes(Number(item.category_id));
//   })

//   // 3️⃣ OTHER FILTERS (unchanged)
//   .filter((item) =>
//     selectedBrands.length > 0 ? selectedBrands.includes(item.brand) : true
//   )
//   .filter((item) =>
//     selectedRatings.length > 0
//       ? selectedRatings.some((rating) => item.rating >= Number(rating))
//       : true
//   )
//   .filter((item) => item.price <= priceRange)
//   .filter((item) => (discountFilter ? item.discount >= discountFilter : true))
//   .sort((a, b) => {
//     if (sortOption === "1") return b.price - a.price;
//     if (sortOption === "2") return a.price - b.price;
//     if (sortOption === "3") return b.discount - a.discount;
//     return 0;
//   });


//   if (loading) {
//     return (
//       <div className="content container-fluid">
//         <div style={{ textAlign: "center", padding: "50px" }}>
//           <p>Loading products...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="content container-fluid">
//         <div style={{ textAlign: "center", padding: "50px", color: "red" }}>
//           <p>{error}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="content container-fluid">
//         <div className="midsize">
//           Home / <span>Products</span>
//         </div>
//         <div className="midsizeplus">
//   {isSearchMode ? "Search Results" : "Products"}
//   <span> - {filteredProducts.length} items</span>
// </div>


//         <div className="right sort">
//           <select name="type" onChange={handleSortChange}>
//             <option value="">Sort By</option>
//             <option value="1">Price : High to Low</option>
//             <option value="2">Price : Low to High</option>
//             <option value="3">Best Discount</option>
//           </select>
//         </div>

//         <div className="row">
//           {/* Left Filters */}
//           <div className="col-lg-2 col-md-3 col-sm-12 filter-left">
//             <div className="filter-heading">FILTERS</div>
//             <div className="filters">
//               <div className="filter-categories">
//   <p>Categories</p>
//   {uniqueCategories.map((catId) => (
//     <div key={catId}>
//       <input
//         type="checkbox"
//         checked={selectedCategories.includes(catId)}
//         onChange={() =>
//           handleCheckboxChange(
//             catId,
//             setSelectedCategories,
//             selectedCategories
//           )
//         }
//       />
//       <label>{categoryMap[catId] || `Category ${catId}`}</label>
//     </div>
//   ))}
// </div>


//               <div className="filter-categories">
//                 <p>Brand</p>
//                 {uniqueBrands.map((brand) => (
//                   <div key={brand}>
//                     <input
//                       type="checkbox"
//                       onChange={() =>
//                         handleCheckboxChange(
//                           brand,
//                           setSelectedBrands,
//                           selectedBrands
//                         )
//                       }
//                     />
//                     <label>{brand}</label>
//                   </div>
//                 ))}
//               </div>

//               <div className="filter-categories">
//                 <p>Price Range</p>
//                 <input
//                   type="range"
//                   min={0}
//                   max={100000}
//                   value={priceRange}
//                   onChange={(e) => setPriceRange(e.target.value)}
//                 />
//                 <p>Under ₹{priceRange}</p>
//               </div>

//               <div className="filter-categories">
//                 <p>Rating</p>
//                 {["4", "3", "2"].map((rating) => (
//                   <div key={rating}>
//                     <input
//                       type="checkbox"
//                       onChange={() =>
//                         handleCheckboxChange(
//                           rating,
//                           setSelectedRatings,
//                           selectedRatings
//                         )
//                       }
//                     />
//                     <label>{rating} ★ & above</label>
//                   </div>
//                 ))}
//               </div>

//               {/* <div className="filter-categories">
//                 <p>Color</p>
//                 {uniqueColors.map((color) => (
//                   <div key={color}>
//                     <input
//                       type="checkbox"
//                       onChange={() =>
//                         handleCheckboxChange(
//                           color,
//                           setSelectedColors,
//                           selectedColors
//                         )
//                       }
//                     />
//                     <label>
//                       <span className={`color-set-${color}`}></span>{" "}
//                       {color.charAt(0).toUpperCase() + color.slice(1)}
//                     </label>
//                   </div>
//                 ))}
//               </div> */}

//               <div className="filter-categories">
//                 <p>Discount</p>
//                 {[10, 40, 60, 80].map((val) => (
//                   <div key={val}>
//                     <input
//                       type="checkbox"
//                       checked={discountFilter === val}
//                       onChange={() => handleDiscountFilter(val)}
//                     />
//                     <label>{val}% and Above</label>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Right Products */}
//           <div className="col-lg-10 col-md-9 col-sm-12 products-right">
//             <div className="row">
//               {filteredProducts.map((item) => (
//                 <div
//                   key={item.id}
//                   className="col-lg-3 col-md-4 col-sm-6 product-list"
//                   onMouseEnter={() => setHoveredItemId(item.id)}
//                   onMouseLeave={() => setHoveredItemId(null)}
//                   style={{ position: "relative" }}
//                 >
//                   <Link to={`/model/${item.id}`} className="product">
//                     <div className="image-container">
//                       {hoveredItemId === item.id && item.images.length > 1 ? (
//                         <Slider {...settings}>
//                           {item.images.map((img, idx) => (
//                             <img key={idx} src={img} alt={`slide-${idx}`} />
//                           ))}
//                         </Slider>
//                       ) : (
//                         <div className="product-img">
//                           <img src={item.images[0]} alt={item.name} />
//                           <div className="product-rating">
//                             <p>
//                               {item.rating} <i className="fa-solid fa-star"></i> |{" "}
//                               {item.viewers}
//                             </p>
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     {hoveredItemId === item.id && (
//                       <div className="wishlist">
//                         <button>
//                           <i className="fa-regular fa-heart"></i> Wishlist
//                         </button>
//                       </div>
//                     )}

//                     <div className="product-detail">
//                       <div className="stock-availability">{item.stock}</div>
//                       <div className="brand">{item.brand}</div>
//                       <div className="name">{item.name}</div>
//                       <div className="price">
//                         ₹{item.price}
//                         <span className="line-through"> ₹{item.oldPrice}</span>
//                         <span className="discount"> ({item.discount}% OFF)</span>
//                       </div>
//                     </div>
//                   </Link>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Products;

import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from "react-router-dom";

const Products = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [discountFilter, setDiscountFilter] = useState(null);
  const [sortOption, setSortOption] = useState("");
  const [priceRange, setPriceRange] = useState(100000);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [categoryMap, setCategoryMap] = useState({});
  const [sellerMap, setSellerMap] = useState({});

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const subcategoryFromUrl = queryParams.get("subcategory"); // menu click
  const categoryFromUrl = queryParams.get("category");       // other pages

  const activeSubcategory = subcategoryFromUrl
    ? Number(subcategoryFromUrl)
    : null;

  const activeCategory = categoryFromUrl
    ? Number(categoryFromUrl)
    : null;

  const categoryIdFromHome = location.state?.categoryId;
  console.log("Category from Home:", categoryIdFromHome);

  // 🆕 Fetch seller mapping
  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const res = await fetch(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration"
        );
        const data = await res.json();

        if (data.status === "true" && Array.isArray(data.data)) {
          const mapping = {};
          data.data.forEach((seller) => {
            mapping[seller.seller_id] = seller.business_name;
          });
          setSellerMap(mapping);
          console.log("Seller mapping loaded:", mapping);
        }
      } catch (err) {
        console.error("Seller fetch failed", err);
      }
    };

    fetchSellers();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        const data = await res.json();

        if (data.success === "1" && Array.isArray(data.row)) {
          const map = {};
          data.row.forEach((cat) => {
            map[Number(cat.category_id)] = cat.category_name;
          });
          setCategoryMap(map);
        }
      } catch (err) {
        console.error("Category fetch failed", err);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    console.log("🔍 DEBUG START");

    console.log(
      "Category from Home:",
      categoryIdFromHome,
      "TYPE:",
      typeof categoryIdFromHome
    );

    console.log(
      "Selected Categories:",
      selectedCategories,
      "TYPE:",
      selectedCategories.map((c) => typeof c)
    );

    console.log(
      "Product category_id list:",
      allProducts.map((p) => p.category_id),
      "TYPE:",
      allProducts.map((p) => typeof p.category_id)
    );

    console.log("🔍 DEBUG END");
  }, [categoryIdFromHome, selectedCategories, allProducts]);

  useEffect(() => {
    // ✅ CASE 1: If coming from search
    if (location.state?.results) {
      console.log("📦 Received search results:", location.state.results);
      console.log("📦 Number of results:", location.state.results.length);
      console.log("📦 Sample result structure:", location.state.results[0]);
      
      // 🔥 Search results already include sellerName from Navbar
      setAllProducts(location.state.results);
      setIsSearchMode(true);

      if (location.state.results.length > 0) {
        const maxPrice = Math.max(
          ...location.state.results.map((p) => p.price)
        );
        setPriceRange(maxPrice);
      }

      setLoading(false);
      return; // Stop here, don't fetch from API
    }

    // ✅ CASE 2: Normal product listing
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
        );

        const data = await response.json();

        if (data.status && Array.isArray(data.data)) {
          // ✅ FILTER ONLY ADMIN APPROVED PRODUCTS
          const approvedProducts = data.data.filter(
            (item) => item.admin_approval === "approval"
          );

          console.log(
            "✅ ADMIN APPROVED PRODUCTS:",
            approvedProducts.map((p) => ({
              product_id: p.product_id,
              admin_approval: p.admin_approval,
              category_id: p.category_id,
              subcategory_id: p.subcategory_id,
            }))
          );

          // ✅ TRANSFORM DATA
          const transformedProducts = approvedProducts.map((product) => ({
            id: product.product_id,
            brand: product.company_name || product.assign_vendor,
            name: product.product_name,
            price: parseFloat(product.current_price),
            oldPrice: parseFloat(product.old_price),
            discount: Math.round(
              ((product.old_price - product.current_price) /
                product.old_price) *
                100
            ),

            // IMPORTANT IDS
            category_id: Number(product.category_id),
            subcategory_id: Number(product.subcategory_id),

            color: product.available_colors,
            images:
              product.multi_image?.length > 0
                ? product.multi_image.map(
                    (img) => `https://cyberathon.com/multivendor/${img}`
                  )
                : ["img/placeholder.jpg"],

            rating: parseFloat(product.rating) || 0,
            stock: product.status || "In Stock",
            description: product.description,
            productDetails: product.product_details,
            
            // 🆕 Add seller name
            sellerName: sellerMap[product.seller_id] || "Unknown Seller",
            seller_id: product.seller_id,
          }));

          setAllProducts(transformedProducts);

          // 🔥 PRIORITY HANDLING
          if (activeSubcategory) {
            setSelectedCategories([]); // ignore category when subcategory active
          } else if (activeCategory) {
            setSelectedCategories([activeCategory]);
          }

          if (categoryIdFromHome) {
            setSelectedCategories([Number(categoryIdFromHome)]);
          }

          if (transformedProducts.length > 0) {
            const maxPrice = Math.max(
              ...transformedProducts.map((p) => p.price)
            );
            setPriceRange(maxPrice);
          }
        }

        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to load products");
        setLoading(false);
      }
    };

    fetchProducts();
  }, [location.state, activeCategory, activeSubcategory, categoryIdFromHome, sellerMap]);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleCheckboxChange = (value, setter, stateArray) => {
    setter(
      stateArray.includes(value)
        ? stateArray.filter((item) => item !== value)
        : [...stateArray, value]
    );
  };

  const handleDiscountFilter = (value) => {
    setDiscountFilter(discountFilter === value ? null : value);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  const uniqueCategories = [
    ...new Set(allProducts.map((p) => Number(p.category_id)).filter(Boolean)),
  ];

  const uniqueBrands = [...new Set(allProducts.map(p => p.brand).filter(Boolean))];
  const uniqueColors = [...new Set(allProducts.map(p => p.color).filter(Boolean))];

  const filteredProducts = allProducts
    // 🔥 1️⃣ SUBCATEGORY FILTER (HIGHEST PRIORITY)
    .filter((item) => {
      if (activeSubcategory) {
        return Number(item.subcategory_id) === activeSubcategory;
      }
      return true;
    })

    // 🔥 2️⃣ CATEGORY FILTER (fallback)
    .filter((item) => {
      if (activeSubcategory) return true; // ignore category when subcategory active
      if (selectedCategories.length === 0) return true;
      return selectedCategories.includes(Number(item.category_id));
    })

    // 3️⃣ OTHER FILTERS (unchanged)
    .filter((item) =>
      selectedBrands.length > 0 ? selectedBrands.includes(item.brand) : true
    )
    .filter((item) =>
      selectedRatings.length > 0
        ? selectedRatings.some((rating) => item.rating >= Number(rating))
        : true
    )
    .filter((item) => item.price <= priceRange)
    .filter((item) => (discountFilter ? item.discount >= discountFilter : true))
    .sort((a, b) => {
      if (sortOption === "1") return b.price - a.price;
      if (sortOption === "2") return a.price - b.price;
      if (sortOption === "3") return b.discount - a.discount;
      return 0;
    });

  if (loading) {
  return (
    <div className="container" style={{ marginTop: "115px" }}>
      
      {/* Banner Skeleton */}
      <div className="skeleton-banner mb-4"></div>

      {/* Subcategory Circles Skeleton */}
      <h4 className="fw-bold mb-4">Shop by Sub Categories</h4>
      <div className="d-flex gap-4 mb-4">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="d-flex flex-column align-items-center gap-2">
            <div className="skeleton-circle"></div>
            <div className="skeleton-label"></div>
          </div>
        ))}
      </div>

      {/* Products + Filters Skeleton */}
      <div className="row">
        <div className="col-lg-2 col-md-3">
          <div className="d-flex flex-column gap-2">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton-line" style={{ width: `${60 + Math.random()*30}%` }}></div>
            ))}
          </div>
        </div>
        <div className="col-lg-10 col-md-9">
          <div className="row">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                <div className="skeleton-product-img"></div>
                <div className="skeleton-line mt-2" style={{ width: "50%" }}></div>
                <div className="skeleton-line mt-1" style={{ width: "80%" }}></div>
                <div className="skeleton-line mt-1" style={{ width: "60%" }}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

  if (error) {
    return (
      <div className="content container-fluid">
        <div style={{ textAlign: "center", padding: "50px", color: "red" }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="content container-fluid">
        <div className="midsize">
          Home / <span>Products</span>
        </div>
        <div className="midsizeplus">
          {isSearchMode ? (
            <>
              Search Results {location.state?.query && `for "${location.state.query}"`}
              <span> - {filteredProducts.length} items</span>
            </>
          ) : (
            <>
              Products
              <span> - {filteredProducts.length} items</span>
            </>
          )}
        </div>

        <div className="right sort">
          <select name="type" onChange={handleSortChange}>
            <option value="">Sort By</option>
            <option value="1">Price : High to Low</option>
            <option value="2">Price : Low to High</option>
            <option value="3">Best Discount</option>
          </select>
        </div>

        <div className="row">
          {/* Left Filters */}
          <div className="col-lg-2 col-md-3 col-sm-12 filter-left">
            <div className="filter-heading">FILTERS</div>
            <div className="filters">
              <div className="filter-categories">
                <p>Categories</p>
                {uniqueCategories.map((catId) => (
                  <div key={catId}>
                    <input
                      type="checkbox"
                      checked={selectedCategories.includes(catId)}
                      onChange={() =>
                        handleCheckboxChange(
                          catId,
                          setSelectedCategories,
                          selectedCategories
                        )
                      }
                    />
                    <label>{categoryMap[catId] || `Category ${catId}`}</label>
                  </div>
                ))}
              </div>

              <div className="filter-categories">
                <p>Brand</p>
                {uniqueBrands.map((brand) => (
                  <div key={brand}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          brand,
                          setSelectedBrands,
                          selectedBrands
                        )
                      }
                    />
                    <label>{brand}</label>
                  </div>
                ))}
              </div>

              <div className="filter-categories">
                <p>Price Range</p>
                <input
                  type="range"
                  min={0}
                  max={100000}
                  value={priceRange}
                  onChange={(e) => setPriceRange(e.target.value)}
                />
                <p>Under ₹{priceRange}</p>
              </div>

              <div className="filter-categories">
                <p>Rating</p>
                {["4", "3", "2"].map((rating) => (
                  <div key={rating}>
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleCheckboxChange(
                          rating,
                          setSelectedRatings,
                          selectedRatings
                        )
                      }
                    />
                    <label>{rating} ★ & above</label>
                  </div>
                ))}
              </div>

              <div className="filter-categories">
                <p>Discount</p>
                {[10, 40, 60, 80].map((val) => (
                  <div key={val}>
                    <input
                      type="checkbox"
                      checked={discountFilter === val}
                      onChange={() => handleDiscountFilter(val)}
                    />
                    <label>{val}% and Above</label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Products */}
          <div className="col-lg-10 col-md-9 col-sm-12 products-right">
            <div className="row">
              {filteredProducts.map((item) => (
                <div
                  key={item.id}
                  className="col-lg-3 col-md-4 col-sm-6 product-list"
                  onMouseEnter={() => setHoveredItemId(item.id)}
                  onMouseLeave={() => setHoveredItemId(null)}
                  style={{ position: "relative" }}
                >
                  <Link to={`/model/${item.id}`} className="product">
                    <div className="image-container">
                      {hoveredItemId === item.id && item.images.length > 1 ? (
                        <Slider {...settings}>
                          {item.images.map((img, idx) => (
                            <img key={idx} src={img} alt={`slide-${idx}`} />
                          ))}
                        </Slider>
                      ) : (
                        <div className="product-img">
                          <img src={item.images[0]} alt={item.name} />
                          <div className="product-rating">
                            <p>
                              {item.rating} <i className="fa-solid fa-star"></i> |{" "}
                              {item.viewers}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {hoveredItemId === item.id && (
                      <div className="wishlist">
                        <button>
                          <i className="fa-regular fa-heart"></i> Wishlist
                        </button>
                      </div>
                    )}

                    <div className="product-detail">
                      <div className="stock-availability">{item.stock}</div>
                      <div className="brand">{item.brand}</div>
                      <div className="name">{item.name}</div>
                      
                      {/* 🆕 Display seller name if available */}
                      {item.sellerName && (
                        <div 
                          className="seller-name" 
                          style={{ 
                            fontSize: "12px", 
                            color: "#666",
                            marginTop: "4px" 
                          }}
                        >
                          Sold by: {item.sellerName}
                        </div>
                      )}
                      
                      <div className="price">
                        ₹{item.price}
                        <span className="line-through"> ₹{item.oldPrice}</span>
                        <span className="discount"> ({item.discount}% OFF)</span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;